import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

export const StyledAllSuppressionListsTooltip = styled(Tooltip)`
    && {
        padding: 8px 16px;
    }

    padding: 8px 16px;
    max-width: 600px;
`;
export const StyledAllSuppressionListsLabel = styled(Text)`
    cursor: pointer;
    padding: 8px 16px;
    color: ${colorsPalettes.blue[400]};
    position: relative;
    z-index: 1;
`;
export const StyledSuppressionListItem = styled.li`
    &::marker {
        font-weight: 400;
    }

    font-weight: 300;
`;
export const StyledSuppressionListItemName = styled.div`
    font-weight: 400;
`;
export const StyledSuppressionListItemSummary = styled.div`
    margin-left: -14px;
`;
export const StyledSuppressionLists = styled.ol`
    margin: 0;
    padding: 0 0 0 14px;
`;
